export enum NavbarNoticeId {
    DEMO_NOTIFICATION,
}
